import React from 'react';
import {useTranslation} from 'react-i18next';

import Dialog from '@material-ui/core/Dialog';
import MuiDialogActions from '@material-ui/core/DialogActions';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import {makeStyles, withStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

// import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import BrandedButton from '../BrandedButton/BrandedButton';

import {dialogActionStyles, dialogContentStyles,
  dialogTitleStyles} from './style';
const DialogTitle = withStyles(dialogTitleStyles)((props) => {
  const {children, classes, ...other} = props;
  return (
    <MuiDialogTitle className={classes.root} {...other}>
      {children}
    </MuiDialogTitle>
  );
});

// const DialogContent = withStyles(dialogContentStyles)(MuiDialogContent);
const DialogActions = withStyles(dialogActionStyles)(MuiDialogActions);
// const ErrorIcon = withStyles(errorIconStyles)(ErrorOutlineIcon);

const useContentStyles = makeStyles(dialogContentStyles);
/**
 * Dialog box for error
 * @param {Object} props
 * @return {ReactElement}
 */
export default function ErrorDialogBox(props) {
  const {message, onHandleClose, open, title} = props;
  const {t} = useTranslation();

  const contentClasses = useContentStyles();

  const handleClose = (event, reason) => {
    onHandleClose(event, reason);
  };

  return (
    <div>
      <Dialog
        onClose={handleClose}
        open={open}
      >
        <DialogTitle onClose={handleClose}>
          {title}
        </DialogTitle>

        <MuiDialogContent className={contentClasses.root}>
          {/* <ErrorIcon /> */}
          <div >
            <Typography className={contentClasses.header}>
              {t('error.uhOh')}
            </Typography>
            <Typography
              className={contentClasses.message}>{message}</Typography>
            <Typography className={contentClasses.message}>
              {t('error.unableToProcessRequest')}
            </Typography>
          </div>
        </MuiDialogContent>
        <DialogActions>
          <BrandedButton
            type="submit"
            variant="outlined"
            color="primary"
            size="large"
            onClick={handleClose}
          >
            {t('common.cancel')}
          </BrandedButton>
        </DialogActions>
      </Dialog>
    </div>
  );
}
